import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import { CAC_ROUTER_LEAVE_LABEL, CAC_MODULE_TITLE } from '../CacConstants';

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};

function RouterLeaveModal({
  routerLeaveModal,
  setRouterLeaveModal,
  confirmNavigation,
}) {
  return (
    <Fragment>
      <PortalModal
        isShowing={routerLeaveModal}
        title={CAC_MODULE_TITLE}
        dialogStyles={currClusterModalStyle}
        onCloseClicked={() => {
          setRouterLeaveModal(false);
        }}
      >
        <p>{CAC_ROUTER_LEAVE_LABEL}</p>

        <div className="text-center" data-test="saveBeforeCloseComponent">
          <GenericButton
            name="Cancel"
            onBtnClick={() => {
              setRouterLeaveModal(false);
            }}
          />
          <GenericButton
            name="Ok"
            onBtnClick={() => {
              confirmNavigation();
            }}
          />
        </div>
      </PortalModal>
    </Fragment>
  );
}

RouterLeaveModal.propTypes = {
  routerLeaveModal: PropTypes.bool,
  setRouterLeaveModal: PropTypes.func,
};

export default memo(RouterLeaveModal);
